import { React, PropTypes } from 'imports';
import { FormattedResource } from '..';
import './MenuItem.less';

export default class MenuItem extends React.Component {
    static get propTypes() {
        return {
            icon: PropTypes.string,
            title: PropTypes.oneOfType([FormattedResource.resourcePropType, PropTypes.node]).isRequired,
            checked: PropTypes.bool,
            disabled: PropTypes.bool,
            className: PropTypes.string,
            onClick: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            checked: false,
            disabled: false,
            className: ''
        }
    }

    _onClick = (event) => {
        if (this.props.onClick) {
            this.props.onClick(this, event);
        }
    }

    render() {
        const { icon, title, checked, disabled, className, children } = this.props;

        return (
            <div
                className={
                    'menu-item ' + className +
                    (checked ? ' checked' : '') +
                    (disabled ? ' disabled' : '')
                }
                onClick={!disabled ? this._onClick : null}>

                <span className="title">
                    {icon ? (<span className={'fa fa-' + icon} />) : null}
                    {checked ? <span className="fa fa-check" /> : null}
                    {
                        title ?
                            React.isValidElement(title) || Array.isArray(title) ? title : <FormattedResource resource={title} /> :
                            null
                    }
                </span>

                {children ? <div className="subitems">{children}</div> : null}
            </div>
        );
    }
}
